import { useEffect } from 'react';
import Env from '../env/Env';
import { useTenantStore } from '../store/tenantStore';

function setLinkRel(rel: string, href?: string) {
  let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!href) {
    if (link) {
      link.remove();
    }
    return;
  }
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}

function setMetaDescription(content: string) {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'description';
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function useTenantBranding() {
  const tenantId = useTenantStore((state) => state.tenantId);
  const isLoggedIn = useTenantStore((state) => state.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      document.title = 'Analytics';
      setMetaDescription('Real-time monitoring and analytics platform.');
      setLinkRel('icon', '');
      setLinkRel('apple-touch-icon', '');
    } else {
      document.title = Env.APP_NAME;
      setMetaDescription(Env.APP_DESCRIPTION);
      setLinkRel('icon', Env.FAVICON_URL);
      setLinkRel('apple-touch-icon', Env.LOGO_URL);
    }
  }, [tenantId, isLoggedIn]);
}
